import React from 'react'
import { Grid, Row, Col, Button, Placeholder, Icon } from 'rsuite'
import { isEmpty } from 'lodash-es'
import './styles.less'
import ExpertName from '../../../components/view/ExpertName'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'

const { Paragraph } = Placeholder

export default function SelectedExpertList({
  schema,
  selectedExpert,
  onClick,
  buttonText,
  confirm,
  confirmButtonText,
  isOpenSearchExpert,
  noButton,
  nextEnable,
  onNextClick = () => {},
  onHideSearchPanel,
  onDelete = () => {},
  onChangeReviewType = () => {}
}) {
  const isAllSelectFalse =
    selectedExpert?.filter((item) => item.isSelected == false)?.length == selectedExpert?.length

  return (
    <>
      <Grid fluid className="selected-expert-list">
        <Row>
          <Col style={{ marginBottom: 20 }} xs={24} sm={24} md={24} lg={24}>
            <h6 className="header">{schema.selectedExpertLabel}</h6>
          </Col>
          {!isEmpty(selectedExpert) &&
            selectedExpert
              .filter((item) => item.isSelected)
              .map((item, index) => (
                <ExpertName
                  name={`${index + 1}) ${item.name}`}
                  email={item.email}
                  group={item.group}
                  emailMarginLeft={20}
                  isSelected={true}
                  status={item.isApproved && item.approvedReviewerDate ? 'เห็นชอบ' : 'รอพิจารณา'}
                  date={item.approvedReviewerDate || item.sendConsiderDate}
                  deletable={item.sendConsiderDate ? false : true}
                  onDelete={()=>{
                    console.log('item',item)
                    onDelete(item)
                  }}
                  reviewType={item.reviewType}
                  onChangeReviewType={(value) => onChangeReviewType(value, item)}
                  enableEditReviewType
                />
              ))}

          {!selectedExpert.find((item) => item.isSelected) && (
            <p style={{ marginLeft: 20 }}>ยังไม่ได้เลือกผู้ทรงคุณวุฒิ</p>
          )}

          <Col style={{ marginBottom: 20, textAlign: 'right' }} xs={24} sm={24} md={24} lg={24}>
            {confirm ? (
              <div>
                {isOpenSearchExpert ? (
                  <>
                    {/* <Button
                      appearance="ghost"
                      onClick={confirm}
                      disabled={isEmpty(selectedExpert) || isAllSelectFalse}
                    >
                      {`บันทึก${confirmButtonText || ''}`}
                    </Button> */}
                    <SaveButton
                      icon="plus"
                      onClick={confirm}
                      disabled={isEmpty(selectedExpert) || isAllSelectFalse}
                    >
                      {`บันทึก${confirmButtonText || ''}`}
                    </SaveButton>

                    {onHideSearchPanel && (
                      // <Button
                      //   appearance="ghost"
                      //   onClick={onHideSearchPanel}
                      //   style={{ marginLeft: 10 }}
                      // >
                      //   {'ซ่อนค้นหา'}
                      // </Button>
                      <CancelButton onClick={onHideSearchPanel} style={{ marginLeft: 10 }}>
                        {'ซ่อนค้นหา'}
                      </CancelButton>
                    )}
                  </>
                ) : (
                  <>
                    {(!isEmpty(selectedExpert) || !isAllSelectFalse) && (
                      // <Button
                      //   appearance="ghost"
                      //   onClick={confirm}
                      //   disabled={isEmpty(selectedExpert) || isAllSelectFalse}
                      // >
                      //   {`บันทึก${confirmButtonText || ''}`}
                      // </Button>
                      <SaveButton
                        icon="plus"
                        onClick={confirm}
                        disabled={isEmpty(selectedExpert) || isAllSelectFalse}
                      >
                        {`บันทึก${confirmButtonText || ''}`}
                      </SaveButton>
                    )}
                    {/* <Button appearance="ghost" onClick={onClick} style={{ marginLeft: 10 }}>
                      {buttonText || schema.buttonAddExpertLabel}
                    </Button> */}
                    <SaveButton icon="plus" onClick={onClick} style={{ marginLeft: 10 }}>
                      {buttonText || schema.buttonAddExpertLabel}
                    </SaveButton>
                  </>
                )}
              </div>
            ) : (
              !noButton && (
                <SaveButton icon="plus" onClick={onClick}>
                  {buttonText || schema.buttonAddExpertLabel}
                </SaveButton>
                // <Button appearance="ghost" onClick={onClick}>
                //   {buttonText || schema.buttonAddExpertLabel}
                // </Button>
              )
            )}

            {nextEnable && selectedExpert.find((item) => item.isSelected) && (
              <SaveButton icon="arrow-right" onClick={onNextClick}>
                {`ถัดไป`}
              </SaveButton>
              // <Button appearance="ghost" onClick={onNextClick} style={{ marginLeft: 10 }}>
              //   {`ถัดไป`}
              // </Button>
            )}
          </Col>
        </Row>
      </Grid>
    </>
  )
}
